var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHideIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.121,
    viewBox: "0 0 20 17.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .hide-icon-a,.hide-icon-b,.hide-icon-d{fill:none;}.hide-icon-a{stroke:currentColor;stroke-width:2px;}.hide-icon-b{stroke:#fff;stroke-width:3px;}.hide-icon-c{stroke:none;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1530 -3755.439)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(997 2972)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hide-icon-a",
    transform: "translate(533 785)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "hide-icon-c",
    cx: 10,
    cy: 7,
    rx: 10,
    ry: 7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "hide-icon-d",
    cx: 10,
    cy: 7,
    rx: 9,
    ry: 6
  })), /*#__PURE__*/React.createElement("g", {
    className: "hide-icon-a",
    transform: "translate(540 789)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "hide-icon-c",
    cx: 3,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "hide-icon-d",
    cx: 3,
    cy: 3,
    r: 2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "hide-icon-a",
    d: "M-20782.078-1926.131l15-15",
    transform: "translate(22314.578 5697.631)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideIcon);
export default __webpack_public_path__ + "static/media/hide-icon.383305c6.svg";
export { ForwardRef as ReactComponent };